import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "table",
  "use": "table-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"table\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M24 1a1 1 0 00-1-1H1a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1V1zm-2 6V3a1 1 0 00-1-1h-4v5h5zm-7 0V2H9v5h6zM9 9h6v6H9V9zM7 7V2H3a1 1 0 00-1 1v4h5zM2 9h5v6H2V9zm15 0h5v6h-5V9zM2 21v-4h5v5H3a1 1 0 01-1-1zm7 1v-5h6v5H9zm8 0v-5h5v4a1 1 0 01-1 1h-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol